export const APP_MAX_WIDTH = 430;
